import { Component, input, InputSignal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { filter, startWith, switchMap } from 'rxjs';
import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';
import { ReferralPageService } from '../referralPage.service';

@Component({
    selector: 'referral-service-provider-fees',
    templateUrl: 'serviceProviderFees.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ServiceProviderFeesComponent {
    constructor(private readonly _referralPageService: ReferralPageService) {}

    referral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    form: InputSignal<FormGroup> = input<FormGroup>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();

    editMode = this._referralPageService.editMode;
    issuesOnAppealOptions: Weissman.Model.NameValuePair[];

    rlsFeeTypeOptions: Weissman.Model.NameValuePair[] = [
        { name: '', value: '' },
        { name: 'N/A', value: Core.RLSFeeTypeEnum.NA.toString() },
        { name: 'Fixed', value: Core.RLSFeeTypeEnum.Fixed.toString() },
        { name: 'Hourly', value: Core.RLSFeeTypeEnum.Hourly.toString() },
        { name: 'Hybrid', value: Core.RLSFeeTypeEnum.Hybrid.toString() },
        { name: 'Included', value: Core.RLSFeeTypeEnum.Included.toString() },
        { name: 'Performance Based', value: Core.RLSFeeTypeEnum.PerformanceBased.toString() },
    ];

    rlsPayorTypeOptions: Weissman.Model.NameValuePair[] = [
        { name: 'Unknown', value: Core.RLSPayorTypeEnum.Unknown.toString() },
        { name: 'Client', value: Core.RLSPayorTypeEnum.Client.toString() },
        { name: 'Ryan', value: Core.RLSPayorTypeEnum.Ryan.toString() },
        { name: 'RLS', value: Core.RLSPayorTypeEnum.RLS.toString() },
    ];

    get isRLSFeeOptional(): boolean {
        const feeTypeId = this._rlsFeeTypeId();

        if (!feeTypeId) {
            return false;
        }

        return (
            this.editMode() &&
            feeTypeId !== Core.RLSFeeTypeEnum.Hourly &&
            feeTypeId !== Core.RLSFeeTypeEnum.Hybrid &&
            feeTypeId !== Core.RLSFeeTypeEnum.PerformanceBased
        );
    }

    get isFixedFeesOptional(): boolean {
        const feeTypeId = this._rlsFeeTypeId();

        if (!feeTypeId) {
            return false;
        }

        return this.editMode() && feeTypeId !== Core.RLSFeeTypeEnum.Fixed;
    }

    private readonly _rlsFeeTypeId = toSignal(
        toObservable(this.form).pipe(
            filter((form): form is FormGroup => !!form),
            switchMap((form) => {
                const control = form.get('rlsFeeTypeId');
                return control.valueChanges.pipe(startWith(control.value));
            }),
        ),
    );
}
